import { useEffect, useState } from "react"
import { getClientesById, patchClientes, patchPassword } from "../../services/ClientesServices"
import { postClientes } from "../../services/clientServices"
import { accountClientes, forgotPasswordData,resetAccountData ,getClienteByIdToken,validateDataClient} from "../../services/ClientesServices"
import { ClienteFormContext } from "./ClienteContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Cliente } from '../../routes/RoutesConstants'

export const ClienteFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getClienteByIdData(id)
    }, [])

    const getClienteByIdData = async (id) => {
        let res = await getClientesById(id)
        return res;
    }

    const getClientAccount = async (formData) => {
        let res = await getClienteByIdToken(formData)
        return res;
    }

    const postClienteData = async (body) => {
        const res = await postClientes(body)
        if (res) navigate("/");
    }

    const patchClienteData = async (id, body) => {
        const res = await patchClientes(id, body)
    }
    const patchActualizarClienteData = async (id, body) => {
        const res = await accountClientes(id, body)
        if (res) navigate("/");
    }

    const forgotPassword = async (body) => {
        const res = await forgotPasswordData(body);
        return res;
    }

    const changePassword = async (body) => {
        const res = await patchPassword(body);
        return res;
    }

     const resetAccount = async (body) => {
        const res = await resetAccountData(body);
        return res;
    }

    
    const updateAccount= async (body) => {
        console.log("updateAccount", body)
        const res = await validateDataClient(body);
        return res;
    }


    return <ClienteFormContext.Provider value={{
        report,
        postClienteData,
        patchClienteData,
        getClienteByIdData,
        getClientAccount,
        patchActualizarClienteData,
        forgotPassword,
        changePassword,
        resetAccount,
        updateAccount
    }} >
        {children}
    </ClienteFormContext.Provider>
}